import { object } from 'yup';
import { TagsValidation } from '../../../constant/validation';

export const tagsValidation = object().shape({
  tags: TagsValidation,
});
